<template>
  <div>dashboard __</div>
</template>

<script>
  export default {
  }
</script>
